<template>
  <section class="news-carousel-section">
    <div class="container">
      <div class="news-carousel-wrapper">
        <!-- 左侧图片轮播 -->
        <div class="news-carousel-left">
          <swiper
            ref="newsSwiper"
            :options="swiperOptions"
            @click="handleSwiperClick"
          >
            <swiper-slide
              v-for="slide in carouselSlides"
              :key="slide.id"
              :data-news-id="slide.id"
              style="cursor: pointer;"
            >
              <div class="carousel-image-wrapper" @click.stop="goToNewsDetail(slide.id)">
                <img :src="slide.image" :alt="slide.title" />
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        
        <!-- 右侧文字列表 -->
        <div class="news-carousel-right">
          <h3 class="news-title">公司新闻</h3>
          <div class="news-grid">
            <div 
              v-for="(news, index) in newsList" 
              :key="index"
              class="news-item"
              @click="goToNewsDetail(news.id)"
            >
              <span class="news-item-title">{{ news.title }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import { newsApi } from '@/api'

export default {
  name: 'NewsCarousel',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      swiperOptions: {
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          bulletActiveClass: 'swiper-pagination-bullet-active'
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        }
      },
      carouselSlides: [],
      newsList: []
    }
  },
  mounted() {
    this.fetchCarouselSlides()
    this.fetchNewsList()
  },
  methods: {
    fetchCarouselSlides() {
      newsApi.getCarouselSlides().then(res => {
        if (res) {
          this.carouselSlides = res.data || []
          console.log('轮播图数据:', this.carouselSlides)
        }
      }).catch(err => {
        console.error('获取轮播图失败:', err)
      })
    },
    fetchNewsList() {
      newsApi.getNewsList().then(res => {
        if (res) {
          this.newsList = res.data || []
        }
      }).catch(err => {
        console.error('获取新闻列表失败:', err)
      })
    },
    goToNewsDetail(newsId) {
      console.log('点击轮播图，新闻ID:', newsId)
      if (newsId) {
        this.$router.push(`/news/${newsId}`)
      } else {
        console.error('新闻ID为空')
      }
    },
    handleSwiperClick() {
      if (this.$refs.newsSwiper && this.$refs.newsSwiper.swiper) {
        const swiper = this.$refs.newsSwiper.swiper
        const activeIndex = swiper.activeIndex
        // 处理loop模式下的索引
        const realIndex = swiper.realIndex
        console.log('Swiper点击事件 - activeIndex:', activeIndex, 'realIndex:', realIndex)
        if (this.carouselSlides.length > 0 && realIndex >= 0 && realIndex < this.carouselSlides.length) {
          const slide = this.carouselSlides[realIndex]
          console.log('当前活动slide:', slide)
          if (slide && slide.id) {
            this.goToNewsDetail(slide.id)
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.news-carousel-section {
  background-color: #f5f7fa;
  padding: 40px 0;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.news-carousel-wrapper {
  display: flex;
  gap: 0;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

/* 左侧轮播区域 */
.news-carousel-left {
  flex: 1;
  min-width: 0;
}

.news-carousel-left >>> .swiper-container {
  width: 100%;
  height: 400px;
}

.news-carousel-left >>> .swiper-slide {
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-image-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
  overflow: hidden;
}

.carousel-image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 轮播指示器样式 */
.news-carousel-left >>> .swiper-pagination {
  bottom: 20px;
}

.news-carousel-left >>> .swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  background: rgba(255, 255, 255, 0.7);
  opacity: 1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.news-carousel-left >>> .swiper-pagination-bullet-active {
  width: 24px;
  border-radius: 5px;
  background: #165DFF;
}

/* 右侧新闻列表 */
.news-carousel-right {
  flex: 1;
  min-width: 0;
  padding: 30px;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.news-title {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #165DFF;
}

/* 两列网格布局 */
.news-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  flex: 1;
}

.news-item {
  display: flex;
  flex-direction: column;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 3px solid transparent;
  transition: all 0.3s ease;
  cursor: pointer;
}

.news-item:hover {
  background: #e8f0fe;
  border-left-color: #165DFF;
  transform: translateX(5px);
}

.news-item-title {
  font-size: 0.8rem;
  color: #333;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  transition: color 0.3s ease;
}

.news-item:hover .news-item-title {
  color: #165DFF;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .news-carousel-wrapper {
    flex-direction: column;
  }
  
  .news-carousel-left >>> .swiper-container {
    height: 300px;
  }
  
  .news-carousel-right {
    padding: 20px;
  }
  
  .news-grid {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  
  .news-item {
    padding: 8px;
  }
}
</style>
